import { Box, Stack, Tooltip } from '@mui/material';
import { OrgSupplier, OrgSupplierLite, PublicSupplier } from 'types/suppliers';
import SupplierLogoAvatar from 'ui-component/SupplierLogo/SupplierLogoAvatar';
import { useTheme } from '@mui/material/styles';
import SupplierInfoWidget from 'ui-component/SupplierLogo/SupplierInfoWidget';

const SupplierLogoPile = ({
  suppliers,
}: {
  suppliers: (OrgSupplier | OrgSupplierLite | PublicSupplier)[];
}) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      spacing={0}
      sx={{
        ml: -0.5, // offset the margin of the first avatar
        mt: -0.5,
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {suppliers.map((supplier) => (
        <Tooltip
          title={<SupplierInfoWidget supplier={supplier} />}
          key={supplier.id}
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: 'white',
                border: '1px solid',
                borderColor: theme.palette.grey[300],
                borderRadius: '8px',
              },
            },
          }}
        >
          {/* add margin to the box so it lines up correctly in a grid on wrap */}
          <Box sx={{ ml: 0.5, mt: 0.5 }}>
            <SupplierLogoAvatar supplier={supplier} />
          </Box>
        </Tooltip>
      ))}
    </Stack>
  );
};

export default SupplierLogoPile;
